module.exports = __webpack_public_path__ + "static/media/AccountLogout.a9a6dc99.svg";